import { useCallback, useEffect, useRef } from 'react';

const LEAVE_DELAY_MS = 500;

export const useScanLeaveReset = (onLeave: VoidFunction) => {
  const leaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onLeaveRef = useRef(onLeave);
  onLeaveRef.current = onLeave;

  const cancelLeaveTimer = useCallback(() => {
    if (leaveTimerRef.current) {
      clearTimeout(leaveTimerRef.current);
      leaveTimerRef.current = null;
    }
  }, []);

  const scheduleLeaveReset = useCallback(() => {
    if (leaveTimerRef.current) return;
    leaveTimerRef.current = setTimeout(() => {
      leaveTimerRef.current = null;
      onLeaveRef.current();
    }, LEAVE_DELAY_MS);
  }, []);

  useEffect(() => cancelLeaveTimer, [cancelLeaveTimer]);

  return { cancelLeaveTimer, scheduleLeaveReset };
};
